<template>
  <div class="cart-content">
    <div v-if="!this.address" class="addr" @click="addAddr">
      <span>添加收货地址</span>
      <i />
    </div>
    <div v-else class="addr">
      <div class="left">
        <div class="name">{{ contacts }} {{ phone }}</div>
        <p class="dan">{{ address }}</p>
        <p class="msg">{{ detailedAddress }}</p>
      </div>
      <div class="right" @click="addAddr">
        <i />
      </div>
    </div>
    <div class="product-list">
      <ul>
        <li v-for="(item, index) in showProducts" :key="index">
          <div class="product-con">
            <div class="img-left">
              <img :src="item.image" alt="" />
            </div>
            <div class="other-right">
              <p>{{ item.productName }}-{{ item.skuName }}</p>
              <div class="price-bottom">
                <div class="price">
                  <b>{{ item.curpayPrice[0].integral }}</b>
                  <span>积分</span>
                  <block v-if="item.curpayPrice[0].money">
                    <span>+</span>
                    <b>{{ item.curpayPrice[0].money }}</b>
                    <span>元</span>
                  </block>
                </div>
                <div class="count">
                  <div class="compute-box">
                    <span
                      class="reduce"
                      @click="computeCount('reduce', item, index)"
                    ></span>
                    <span class="input">{{ item.count }}</span>
                    <span
                      class="add"
                      @click="computeCount('add', item, index)"
                    ></span>
                  </div>
                  <i class="delete-icon" @click="deleteProduct(item, index)" />
                </div>
              </div>
            </div>
          </div>
          <div class="combine" v-if="item.isGroup">
            <p>组合商品明细</p>
            <div
              class="combine_item"
              v-for="(ele, key) in item.group"
              :key="key"
            >
              <span>{{ ele.name }}</span>
              <span>X{{ ele.count }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <van-sticky :offset-bottom="50" position="bottom">
      <div class="submit-btn">
        <div class="left">
          <span class="heji">合计</span>
          <b>{{ integralTotal }}</b>
          <span class="jifen">积分</span>
          <block v-if="moneTotal">
            <span>+</span>
            <b>{{ moneTotal }}</b>
            <span class="jifen">元</span>
          </block>
        </div>
        <div class="right">
          <span @click="submitOrder">去结算</span>
        </div>
      </div>
    </van-sticky>
    <!-- 添加地址弹窗 -->
    <van-popup v-model="addrShow" :style="{ height: '70%' }" position="bottom">
      <div class="popupBox" style="padding-bottom: 80px">
        <div class="title">
          <h3>填写地址</h3>
          <i @click="addrShow = false"></i>
        </div>
        <div class="addr-input" :class="focusIndex === 0 ? 'active' : ''">
          <span>姓名</span>
          <input
            type="text"
            @focus="focusActive('name')"
            @blur="scrollTop"
            v-model="contacts"
            placeholder="请输入"
          />
        </div>
        <div class="addr-input" :class="focusIndex === 1 ? 'active' : ''">
          <span>手机号</span>
          <input
            type="number"
            @focus="focusActive('phone')"
            @blur="scrollTop"
            v-model="phone"
            placeholder="请输入"
          />
        </div>
        <div
          class="addr-input-choose"
          :class="focusIndex === 2 ? 'active' : ''"
          @click="chooseProvinces"
        >
          <span>所在地</span>
          <span v-if="!address" class="input">请选择</span>
          <span v-else class="input">{{ address }}</span>
          <i></i>
        </div>
        <div class="addr-input-del" :class="focusIndex === 3 ? 'active' : ''">
          <p>详细地址</p>
          <textarea
            name=""
            id=""
            @focus="focusActive('detailedAddress')"
            @blur="scrollTop"
            v-model="detailedAddress"
            placeholder="请输入"
          ></textarea>
        </div>
        <div class="fixed-button" @click="sumbitTake">
          <span>保存并使用</span>
        </div>
      </div>
    </van-popup>
    <ToBack />
    <AddressTemp
      :address-popup="addressPopup"
      @closePopup="closePopup"
      @getAddr="getAddr"
      :addr="addrList"
      :color="'#D80A68'"
    />
  </div>
</template>

<script>
import http from "../common/http.js";
import ToBack from "./common/toback.vue";
import AddressTemp from "./common/address.vue";
import { Toast, Dialog } from "vant";
var wx = require("weixin-js-sdk");
export default {
  components: { ToBack, AddressTemp },
  data() {
    return {
      addrEmpty: "11",
      value: 1,
      show: false,
      addressPopup: false,
      addrList: [],
      address: "",
      province: "",
      province_code: "",
      city: "",
      city_code: "",
      area: "",
      area_code: "",
      town: "",
      town_code: "",
      addrShow: false,
      focusIndex: null,
      detailedAddress: "",
      contacts: "",
      phone: "",
      productList: JSON.parse(sessionStorage.getItem("ykygoodsList")) || [],
      showProducts: [],
      cacheGoods: JSON.parse(sessionStorage.getItem("ykygoodsList")) || [],
      submitCaution:
        sessionStorage.getItem("submitCaution") ||
        "提交订单后不支持修改地址及退单",
      userIntegral: Number(this.$route.query.userIntegral) || 0,
    };
  },
  created() {
    if (this.cacheGoods) {
      this.showProducts = this.cacheGoods.filter((el) => {
        return el.count !== 0;
      });
    }
    // this.addrRecord = JSON.parse(localStorage.getItem('ykyAddr')) || {}
    // let addr = this.addrRecord
    // if (addr) {
    //   this.address = addr.province + addr.city + addr.area + addr.town
    //   this.contacts = addr.contacts
    //   this.phone = addr.phone
    //   this.province = addr.province
    //   this.province_code = addr.province_code
    //   this.city = addr.city
    //   this.city_code = addr.city_code
    //   this.area = addr.area
    //   this.area_code = addr.area_code
    //   this.town = addr.town
    //   this.town_code = addr.town_code
    //   this.addr = addr.detailedAddress
    //   this.detailedAddress = addr.detailedAddress
    // }
  },
  mounted() {
    this.iosScrollFix("login-wrapper");
    this.getUserAddr();
    // localStorage.removeItem("ykygoodsList");
  },
  computed: {
    integralTotal() {
      let total = 0;
      this.showProducts &&
        this.showProducts.forEach((v) => {
          total += v.curpayPrice[0].integral * v.count;
        });
      return total;
    },
    moneTotal() {
      let total = 0;
      this.showProducts &&
        this.showProducts.forEach((v) => {
          if (v.curpayPrice[0].money) {
            total += v.curpayPrice[0].money * v.count;
          }
        });
      return total.toFixed(2);
    },
  },
  methods: {
    getAddr(adr) {
      this.address = "";
      this.addrList = adr;
      adr.forEach((v) => {
        this.address += v.n;
        if (v.c.length === 2) {
          this.province = v.n;
          this.province_code = v.c;
        }
        if (v.c.length === 4) {
          this.city = v.n;
          this.city_code = v.c;
        }
        if (v.c.length === 6) {
          this.area = v.n;
          this.area_code = v.c;
        }
        if (v.c.length === 9) {
          this.town = v.n;
          this.town_code = v.c;
        }
      });
    },
    // 获取用户地址
    getUserAddr() {
      http.get("/integral/public/addr/get").then((res) => {
        this.address = res.province + res.city + res.area + res.town;
        this.contacts = res.contacts;
        this.phone = res.phone;
        this.province = res.province;
        this.province_code = res.provinceCode;
        this.city = res.city;
        this.city_code = res.cityCode;
        this.area = res.area;
        this.area_code = res.areaCode;
        this.town = res.town;
        this.town_code = res.townCode;
        this.addr = res.addr;
        this.detailedAddress = res.addr;
      });
    },
    submitOrder() {
      if (this.showProducts.length === 0) {
        this.$toast("请选择需要兑换的商品");
        return;
      }
      let flag = false,
        tips = "";
      this.showProducts.forEach((v) => {
        if (v.stock === 0) {
          flag = true;
          tips = v.name + "无可兑换数量";
        }
      });
      if (flag) {
        this.$toast(tips);
        return;
      }
      if (!this.address) {
        this.$toast("请填写收货地址");
        return;
      }
      Dialog.confirm({
        message: this.submitCaution,
      })
        .then(() => {
          console.log(this.showProducts);
          console.log(this.city_code);
          let arr = [];
          let obj = {};
          this.showProducts.forEach((v) => {
            obj = {
              skuId: v.skuId,
              count:Number(v.count),
              payPrice: v.curpayPrice[0],
              group: v.group,
            };
            arr.push(obj);
          });
          let data = {
            province: this.province,
            provinceCode: this.province_code,
            city: this.city,
            cityCode: this.city_code,
            area: this.area,
            areaCode: this.area_code,
            town: this.town,
            townCode: this.town_code,
            addr: this.detailedAddress,
            contacts: this.contacts,
            phone: this.phone,
            productList: arr,
          };
          http.post("/integral/public/exchange/product", data).then((res) => {
            if (res.data.state == 1) {
              this.wxpay(res.data.payInfo);
            } else {
              this.$router.push("/exchangeSuccess?data=" + JSON.stringify(res));
              sessionStorage.removeItem("ykygoodsList");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    async wxpay(d) {
      let that = this;
      wx.config({
        debug: false, // 开启调试模式,成功失败都会有alert框
        appId: d.Appid, // 必填，公众号的唯一标识
        timestamp: d.Timestamp, // 必填，生成签名的时间戳
        nonceStr: d.NonceStr, // 必填，生成签名的随机串
        signature: d.PaySign, // 必填，签名
        jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
      });
      wx.ready(() => {
        wx.chooseWXPay({
          timestamp: d.Timestamp,
          nonceStr: d.NonceStr,
          package: d.Package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: d.SignType,
          paySign: d.PaySign, //支付签名
          success: function (res) {
            // 支付成功后的回调函数
            // alert(111)
            that.$router.push("/exchangeSuccess?data=" + JSON.stringify(res));
            sessionStorage.removeItem("ykygoodsList");
          },
          cancel: function (res) {
            //支付取消
            console.log(res,'res')
            that.$router.go(-1);
          },
          fail: function (res) {
            // alert(res)
            console.log(res,'res')
            // 支付失败回调函数
          },
        });
      });
    },
    // input输入框聚焦事件
    focusActive(type) {
      if (type === "name") {
        this.focusIndex = 0;
      }
      if (type === "phone") {
        this.focusIndex = 1;
      }
      if (type === "detailedAddress") {
        this.focusIndex = 3;
      }
    },
    closePopup() {
      this.addressPopup = false;
    },
    // 提交填写的地址
    sumbitTake() {
      this.contacts = this.contacts.replace(/\s/g, "");
      if (!this.contacts || this.contacts.length < 2) {
        Toast("姓名有误");
        return;
      }
      if (!this.phone || this.phone.length !== 11) {
        Toast("手机号有误");
        return;
      }
      // const reg = /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/
      // if (!reg.test(this.phone)) {
      //   this.$toast('请输入正确的手机号')
      //   return
      // }
      if (!this.province || !this.city || !this.area || !this.town) {
        Toast("请选择地址");
        return;
      }
      this.detailedAddress = this.detailedAddress.replace(/\s/g, "");
      if (!this.detailedAddress) {
        Toast("请输入详细地址");
        return;
      }
      this.addrShow = false;
      this.addrRecord = {
        contacts: this.contacts,
        phone: this.phone,
        province: this.province,
        city: this.city,
        area: this.area,
        town: this.town,
        addr: this.detailedAddress,
        provinceCode: this.province_code,
        cityCode: this.city_code,
        areaCode: this.area_code,
        townCode: this.town_code,
      };
      http.post("/integral/public/addr/add", this.addrRecord).then((res) => {
        console.log(res);
        this.$toast("操作成功");
      });
    },
    // 添加地址
    addAddr() {
      if (!this.address) {
        // 没有添加过地址信息
        this.isModify = 0;
        this.address = "";
        this.detailedAddress = "";
      }
      this.focusIndex = null;
      this.addrShow = true;
    },
    // 点击选择地址
    chooseProvinces() {
      this.addressPopup = true;
    },
    // 加减商品数量
    computeCount(type, item, index) {
      if (type === "add") {
        // if (this.integralTotal + Number(item.integral) > this.userIntegral) {
        //   Toast("当前积分不足");
        //   return;
        // }
        // item.count++;
        this.showProducts.forEach((v) => {
          if (v.skuId === item.skuId && v.curpayPrice == item.curpayPrice) {
            v.count++;
            // this.$set(this.showProducts[index], "count", v.count++);
          }
        });
        sessionStorage.setItem("ykygoodsList", JSON.stringify(this.showProducts));
        console.log(this.showProducts, "++");
      } else if (type === "reduce") {
        if (item.count === 1) {
          Dialog.confirm({
            message: "是否确认删除此商品",
          })
            .then(() => {
              this.showProducts.splice(index, 1);
              this.showProducts.forEach((v) => {
                if (v.skuId === item.skuId) {
                  v.count = 0;
                }
              });
              sessionStorage.setItem(
                "ykygoodsList",
                JSON.stringify(this.showProducts)
              );
            })
            .catch(() => {
              // on cancel
            });
        } else {
          // item.count--;
          this.showProducts.forEach((v) => {
            if (v.skuId === item.skuId && v.curpayPrice == item.curpayPrice) {
              v.count--;
              // this.$set(this.showProducts[index], "count", v.count--);
            }
          });
          sessionStorage.setItem(
            "ykygoodsList",
            JSON.stringify(this.showProducts)
          );
          console.log(this.showProducts, "--");
          sessionStorage.setItem(
            "ykygoodsList",
            JSON.stringify(this.showProducts)
          );
        }
      }
    },
    // 删除商品
    deleteProduct(item, index) {
      Dialog.confirm({
        message: "是否确认删除此商品",
      })
        .then(() => {
          let i = 0;
          this.productList.forEach((v, index) => {
            if (v.skuId === item.skuId && v.curpayPrice == item.curpayPrice) {
              i = index;
            }
          });
          this.productList[i].count = 0;
          this.showProducts.splice(index, 1);
          sessionStorage.setItem(
            "ykygoodsList",
            JSON.stringify(this.showProducts)
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    // iphone input 输入法 弹窗将页面顶起 解决办法
    scrollTop() {
      window.scrollTo(0, 0);
    },
    // ios手机频繁滑动后会出现页面假死的bug
    iosScrollFix(className) {
      var startY, startTopScroll;
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        var temp = document.querySelectorAll(className);
        var tempLen = temp.length;
        for (var i = 0; i < tempLen; ++i) {
          let j = i;
          temp[j].addEventListener(
            "touchstart",
            function (event) {
              startY = event.touches[0].pageY;
              startTopScroll = temp[j].scrollTop;
            },
            false
          );
          temp[i].addEventListener("touchmove", function (event) {
            var startY2 = event.touches[0].pageY;
            if (startTopScroll <= 0 && startY2 - startY > 0) {
              event.preventDefault();
            }
            if (
              startTopScroll + temp[j].offsetHeight >= temp[j].scrollHeight &&
              startY2 - startY < 0
            ) {
              event.preventDefault();
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-content {
  padding-top: 10px;
  .addr {
    padding: 20px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px;
    span {
      color: #333333;
      font-size: 16px;
    }
    i {
      display: block;
      width: 16px;
      height: 16px;
      background: url("../image/yky/箭头.png") no-repeat;
      background-size: contain;
    }
    .left {
      flex: 1;
      .name {
        font-size: 16px;
        font-weight: bold;
      }
      .dan {
        color: #666666;
        font-size: 14px;
        margin: 4px 0;
      }
      .msg {
        font-size: 14px;
      }
    }
    .right {
      width: 20px;
      i {
        display: block;
        width: 20px;
        height: 20px;
        background: url("../image/yky/修改地址.png") no-repeat;
        background-size: contain;
      }
    }
  }

  .product-list {
    margin-top: 10px;
    padding-bottom: 100px;
    ul {
      li {
        // border-bottom: 1px solid #f5f6fa;
        background: #fff;
        padding: 0 15px;
        padding-bottom: 16px;
        border-radius: 12px;
        margin-bottom: 1px;
        .product-con {
          padding: 20px 0;
          display: flex;
          &:last-child {
            border: none;
          }
          .img-left {
            width: 98px;
            height: 98px;
            border-radius: 12px;
            background: #f5f6fa;
            margin-right: 10px;
            border-radius: 12px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 12px;
            }
          }
          .other-right {
            display: flex;
            flex-direction: column;
            position: relative;
            flex: 1;
            p {
              font-size: 15px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 2;
            }
            .price-bottom {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              .price {
                color: #d80a68;
                font-weight: bold;
                font-size: 12px;
                flex: 1;
                b {
                  font-size: 16px;
                  margin-right: 2px;
                }
              }
              .count {
                flex: 1;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                .compute-box {
                  display: flex;
                  span {
                    display: block;
                    width: 22px;
                    height: 22px;
                  }
                  .reduce {
                    background: url("../image/subtracttwo1@2x.png") no-repeat;
                    background-size: contain;
                  }
                  .add {
                    background: url("../image/plus@2x.png") no-repeat;
                    background-size: contain;
                  }
                  .input {
                    width: 42px;
                    height: 22px;
                    line-height: 22px;
                    background: #f5f8fb;
                    border-radius: 4px;
                    text-align: center;
                  }
                }
                .delete-icon {
                  display: block;
                  width: 24px;
                  height: 24px;
                  background: url("../image/yky/Gb@2x.png") no-repeat;
                  background-size: contain;
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    .left {
      .heji {
        color: #666666;
        font-size: 12px;
      }
      b {
        font-size: 18px;
        color: #222222;
        font-weight: bold;
        margin: 0 2px;
      }
      .jifen {
        color: #333333;
        font-size: 14px;
      }
    }
    .right {
      width: 100px;
      span {
        display: block;
        width: 100px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #d80a68;
        border-radius: 20px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        &:active {
          background: rgba(216, 10, 104, 0.8);
        }
      }
    }
  }
}

// 填写地址弹窗样式
.popupBox {
  padding: 0 20px;
  .title {
    height: 1.26rem;
    line-height: 1.26rem;
    font-size: 0.32rem;
    text-align: center;
    position: relative;
    i {
      display: block;
      width: 18px;
      height: 18px;
      background: url("../image/Gb@2x.png") no-repeat;
      background-size: contain;
      position: absolute;
      right: 10px;
      top: 22px;
    }
  }
  .searchText {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f3f4f6;
    border-radius: 20px;
    position: relative;
    padding-left: 16px;
    i {
      display: block;
      width: 0.34rem;
      height: 0.34rem;
      background: url("../image/serch.png") no-repeat;
      background-size: contain;
      position: absolute;
      left: 12px;
      top: 8px;
    }
    input {
      width: 100%;
      height: 100%;
      padding-left: 16px;
      border-radius: 20px;
      background: #f3f4f6;
    }
  }
  .addr-input {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    margin-bottom: 12px;
    border-radius: 8px;
    &.active {
      background: rgba(216, 10, 104, 0.03);
      border: 1px solid #d80a68;
      input {
        background: rgba(216, 10, 104, 0.01);
      }
    }
    span {
      width: 90px;
      font-size: 14px;
      padding-left: 20px;
    }
    input {
      flex: 1;
      height: 100%;
      background: #f2f2f5;
      border-radius: 8px;
    }
  }
  .addr-input-choose {
    width: 100%;
    min-height: 48px;
    display: flex;
    align-items: center;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    margin-bottom: 12px;
    border-radius: 8px;
    &.active {
      background: rgba(216, 10, 104, 0.03);
      border: 1px solid #d80a68;
      .input {
        background: rgba(216, 10, 104, 0.01);
      }
    }
    span {
      width: 90px;
      font-size: 14px;
      padding-left: 20px;
    }
    .input {
      padding-left: 0;
      flex: 1;
      height: 100%;
      // line-height: 50px;
      color: #999999;
      background: #f2f2f5;
      border-radius: 8px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
    i {
      margin-right: 16px;
      display: block;
      width: 8px;
      height: 12px;
      background: url("../image/1@2x.png") no-repeat;
      background-size: contain;
    }
  }
  .addr-input-del {
    width: 100%;
    height: 163px;
    background: #f2f2f5;
    border: 1px solid #f2f2f5;
    border-radius: 8px;
    padding: 15px 15px 10px 20px;
    &.active {
      background: rgba(216, 10, 104, 0.03);
      border: 1px solid #d80a68;
      textarea {
        background: rgba(216, 10, 104, 0.01);
      }
    }
    p {
      font-size: 14px;
    }
    textarea {
      font-size: 14px;
      width: 100%;
      height: 90%;
      background: #f2f2f5;
      padding: 15px 0 10px 0;
    }
  }

  .fixed-button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 30px;
    height: 62px;
    background: #fff;
    box-shadow: 1px 3px 4px 4px rgba(247, 241, 241, 0.5);
    span {
      height: 46px;
      line-height: 46px;
    }
    button {
      height: 48px;
      line-height: 48px;
    }
    span,
    button {
      display: block;
      width: 100%;
      text-align: center;
      background: #d80a68;
      border-radius: 30px;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      position: relative;
      z-index: 1000;
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        right: 50%;
        bottom: 50%;
        width: 100%;
        height: 100%;
        background: #000;
        border: inherit;
        border-color: #000;
        border-radius: 30px;
        transform: translate(-50%, -50%);
        opacity: 0;
        content: "";
      }
      &:active::before {
        opacity: 0.2;
      }
    }
  }
}
.combine {
  p {
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 18px;
  }
  .combine_item {
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    span:nth-of-type(1) {
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>